import { useAtom } from 'jotai'
import { VStack, HStack, Button, Separator, Text } from '@chakra-ui/react'
import { cardInfoAtom, newCardTokenAtom, newCardInfoAtom } from '@!/atoms/paymentAtom'

export const CreditCardInfo = ({ handleChangeCard }) => {
  const [cardInfo] = useAtom(cardInfoAtom)
  const [newCardToken] = useAtom(newCardTokenAtom)
  const [newCardInfo] = useAtom(newCardInfoAtom)
  const currentCard = newCardToken ? newCardInfo : cardInfo

  return (
    <VStack w={'full'} gap={4} alignItems="stretch">
      {!newCardToken ? (
        <>
          <HStack w={'full'} justify={'space-between'}>
            <Text fontWeight={'bold'}>前回使用したカード</Text>
            <Button size={'xs'} fontSize={'2xs'} onClick={handleChangeCard}>
              他のカードを使う
            </Button>
          </HStack>
          <Separator />
        </>
      ) : null}

      <HStack w={'full'} justify={'space-between'} fontSize={'2xs'}>
        <Text>クレジットカード番号</Text>
        <Text>{currentCard?.number}</Text>
      </HStack>
      <Separator />
    </VStack>
  )
}
